import React from 'react';
import PropTypes from 'prop-types';

const CalciteOption = ({id, className, disabled, label, selected, value, children}) => {
  return (
    <calcite-option
      id={id ?? undefined}
      class={className ?? undefined}
      disabled={disabled ?? undefined}
      label={label ?? undefined}
      selected={selected ?? undefined}
      value={value ?? undefined}
    >
      {children}
    </calcite-option>
  );
};

CalciteOption.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  selected: PropTypes.bool,
  value: PropTypes.any,
  children: PropTypes.node,
};

export default CalciteOption;
